import type from '../actionsType';

const doSnakbar = (payload) => ({
    type: type.SET_SNAKBAR_INFO,
    payload
});

export {
    doSnakbar
}